import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/football', label: '足球' },
  { path: '/category/basketball', label: '篮球' },
  { path: '/category/tennis', label: '网球' },
  { path: '/category/esports', label: '电竞' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="container-custom">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-9 h-9 md:w-10 md:h-10 bg-primary-500 rounded-lg flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
              <span className="text-background-50 font-heading text-lg md:text-xl font-bold">bb</span>
            </div>
            <span className={`font-heading text-xl md:text-2xl font-bold tracking-tight transition-colors duration-300 ${scrolled ? 'text-foreground-900' : 'text-background-50'}`}>
              bb体育
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path || (link.path !== '/' && location.pathname.startsWith(link.path));
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-500/10 text-primary-600'
                      : scrolled
                        ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                        : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-4 py-2 rounded-md border text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
              style={{
                borderColor: scrolled ? 'oklch(var(--primary-500))' : 'oklch(0.985 0.002 95 / 0.5)',
                color: scrolled ? 'oklch(var(--primary-500))' : 'oklch(0.985 0.002 95)',
              }}
            >
              登录
            </Link>
            <Link
              to="/about"
              className="px-5 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-semibold transition-all duration-200 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              立即注册
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors duration-200"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${scrolled ? 'text-foreground-900' : 'text-background-50'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg animate-in slide-in-from-top">
          <div className="container-custom py-4 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path || (link.path !== '/' && location.pathname.startsWith(link.path));
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 ${
                    isActive ? 'bg-primary-500/10 text-primary-600' : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <div className="flex gap-3 mt-3 px-4">
              <Link to="/about" className="flex-1 py-2.5 rounded-md border border-primary-500 text-primary-600 text-sm font-medium text-center whitespace-nowrap cursor-pointer">
                登录
              </Link>
              <Link to="/about" className="flex-1 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold text-center whitespace-nowrap cursor-pointer">
                立即注册
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}